<template>
  <div class="pl-5 ml-2 h-100">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <a
      class="btn btn-primary d-block d-sm-none"
      data-toggle="collapse"
      href="#addLive"
      role="button"
      aria-expanded="false"
      aria-controls="collapseExample"
    >新增現場來賓</a>
    <div class="row h-100">
      <addLiveGuests />
      <div class="col-12 col-sm-8 col-xl-10 px-sm-0 pt-4 guestList">
        <div class="container-fluid mb-4">
          <div class="row justify-content-between">
            <div class="col-xl-5 mb-3 mb-xl-0">
              <div class="row">
                <div class="col-md-4">
                  <div class="card numberBox brown">
                    <div class="card-body">
                      <h5 class="card-title">現場號碼:</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ allTime.LiveNumber }}</h6>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card numberBox brown">
                    <div class="card-body">
                      <h5 class="card-title">網路號碼:</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ allTime.NetWorkNumber }}</h6>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card numberBox brown">
                    <div class="card-body">
                      <h5 class="card-title">目前過號:</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ overnumber }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 d-flex align-self-end mb-3 mb-xl-0 searchBox">
              <img src="@/assets/img/search.svg" alt="search" style="width: 30px;" />
              <input
                class="form-control mr-sm-2"
                type="search"
                placeholder="手機或姓名"
                aria-label="手機或姓名"
                v-model="searchKeyWord"
                @change="search"
              />
            </div>
            <div class="col-xl-2 align-self-end">
              <ul class="nav nav-pills" id="pills-tab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-item nav-link active"
                    id="pills-on-line-tab"
                    data-toggle="pill"
                    href="#pills-on-line"
                    role="tab"
                    aria-controls="pills-on-line"
                    aria-selected="true"
                  >網路</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-item nav-link"
                    id="pills-live-tab"
                    data-toggle="pill"
                    href="#pills-live"
                    role="tab"
                    aria-controls="pills-live"
                    aria-selected="false"
                  >現場</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-on-line"
            role="tabpanel"
            aria-labelledby="pills-on-line-tab"
          >
            <onLine />
          </div>
          <div
            class="tab-pane fade"
            id="pills-live"
            role="tabpanel"
            aria-labelledby="pills-live-tab"
          >
            <onSite />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addLiveGuests from '@/components/AddLiveGuests.vue'
import onSite from '@/components/OnSite.vue'
import onLine from '@/components/OnLine.vue'

export default {
  components: {
    addLiveGuests,
    onSite,
    onLine
  },
  data () {
    return {
      overnumber: '',
      searchKeyWord: '',
      isLoading: false
    }
  },
  computed: {
    allTime () {
      return this.$store.state.AllBookInfo
    }
  },
  methods: {
    search () {
      this.$store.dispatch('search', this.searchKeyWord)
    }
  },
  created () {
    this.isLoading = true
    const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
    const vm = this
    this.$store.dispatch('BusinessUser')
    this.axios
      .get('http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo', {
        params: { email: adminEmail }
      })
      .then(res => {
        this.axios
          .get('http://imrebooksystem.rocket-coding.com/Dashboard/OverNumber', {
            params: { id: res.data.Id }
          })
          .then(function (res) {
            vm.overnumber = res.data
            vm.isLoading = false
          })
          .catch(error => console.error(error))
      })
      .catch(error => {
        console.error(error)
      })
  }
  // created () {
  //   const mail =JSON.parse(localStorage.getItem('userEmail')
  //   let vm = this
  //   vm.$store.dispatch('BusinessUser', mail)
  // }
}
</script>

<style lang="scss" scoped>
input{
  background-color: transparent;
  border: 0;
  color: #B8817D;
}
input:focus{
  background-color: transparent;
  border: 0;
  color: #B8817D;
}
.numberBox{
  background-color: transparent;
}
.searchBox{
  border: 1px solid #DADBE6;
  border-radius: 5px;
}
.nav-link.active{
  background-color: #E6DBDA !important;
  color: #B8817D;
}
a{
  color: #B8817D;
}
</style>
